import OwnerExpenditure from './OwnerExpenditure.vue';

export default OwnerExpenditure;